import { apiGet } from '@/store/api';
import { EmailGenerationOptions } from './generateDocument';

export async function getEmailTemplateRecipients(location: string, agencyId: number | string, templateId: number | string, portcallId: number | string): Promise<NonNullable<EmailGenerationOptions['recipients']>> {
  const templates: unknown = await apiGet(`mail/templates/${encodeURIComponent(location)}/${agencyId}/true?portcallId=${portcallId}&templateId=${templateId}`);
  const recipients = Array.isArray(templates)
    ? templates.find((template) => Number(template.ID) === Number(templateId))?.RECIPIENTS
    : undefined;
  if (!recipients || !['to', 'cc', 'bcc'].every((category) => Array.isArray(recipients[category])
    && recipients[category].every((recipient: { EMAIL?: unknown } | null) => recipient && typeof recipient.EMAIL === 'string'))) {
    throw new Error('The email template recipients could not be loaded.');
  }
  return recipients;
}